<template>
  <div class="field-validator">
    <slot :isValid="isValid" :hasError="hasError"></slot>
  </div>
</template>

<script>
import { isEmpty } from '@/helpers/array'

export const EVENT_TYPES = {
  demand: 'demand',
  blur: 'blur',
  change: 'change',
}

export const isEventType = value => {
  return Object.values(EVENT_TYPES).includes(value)
}

export default {
  name: 'FieldValidator',

  props: {
    validators: {
      type: Array,
      default: () => [],
      validator(value) {
        return value.every(validator => typeof validator === 'function')
      },
    },
    value: {
      required: true,
    },
    isRequired: {
      type: Boolean,
    },
    hasFocus: {
      type: Boolean,
      default: false,
    },
    updateIsValidOn: {
      type: Array,
      default: () => [EVENT_TYPES.change, EVENT_TYPES.blur],
      validator(value) {
        return value.every(isEventType)
      },
    },
    setHasErrorOn: {
      type: Array,
      default: () => [EVENT_TYPES.blur],
      validator(value) {
        return value.every(isEventType)
      },
    },
  },

  data() {
    return {
      isValid: false,
      hasError: false,
      failedValidatorIndex: -1,
    }
  },

  watch: {
    value() {
      this.updateOn(EVENT_TYPES.change)
    },

    hasFocus() {
      this.updateOn(EVENT_TYPES.blur)
    },

    isValid: {
      immediate: true,
      handler(isValid) {
        this.$emit('isValid', isValid)
      },
    },

    isRequired: {
      immediate: true,
      handler(isRequired) {
        if (!isRequired && !this.value) {
          this.isValid = true
        }
      },
    },

    hasError(hasError) {
      this.$emit('hasError', hasError)
    },

    failedValidatorIndex(failedValidatorIndex) {
      this.$emit('failedValidatorIndex', failedValidatorIndex)
    },
  },

  created() {
    if (this.value) {
      this.updateOn(EVENT_TYPES.change)
      this.updateOn(EVENT_TYPES.blur)
    }
  },

  methods: {
    updateOn(eventType = EVENT_TYPES.demand) {
      if (eventType === EVENT_TYPES.blur && this.hasFocus) return
      if ([...this.updateIsValidOn, EVENT_TYPES.demand].includes(eventType)) this.updateIsValid()
      if ([...this.setHasErrorOn, EVENT_TYPES.demand].includes(eventType)) this.setHasError()
      this.clearHasError()
    },

    forceShowError() {
      this.isValid = false
      this.hasError = true
    },

    forceHideError() {
      this.hasError = false
    },

    updateIsValid() {
      if (isEmpty(this.validators)) {
        this.isValid = true
      } else {
        this.failedValidatorIndex = this.validators.findIndex(validator => !validator(this.value))
        this.isValid = this.failedValidatorIndex < 0
      }
    },

    setHasError() {
      if (!this.isValid) this.hasError = true
    },

    clearHasError() {
      if (this.isValid) this.hasError = false
    },
  },
}
</script>
